import '@/styles/components/nav.scss';

import { useState } from 'react';

import { NavCollapsible } from '@/components/global/nav/collapsible';
import { LinkWithTitle } from '@/components/links';
import { AnchorWithTitle } from '@/components/links/anchor';
import { AddOnsList } from '@/components/add-ons/list';
import { SpecialEventsList } from '@/components/special-events/list';
import BuyBtn from '../../buttons/BuyBtn';
import CallBtn from '../../buttons/CallBtn';

import { btn } from '@/styles/components/buttons.module.scss';

import logo from '@/images/logos/tbba-logo.png';
import { AreasList } from '@/components/areas/list';
import { DestinationsList } from '@/components/destinations/list';

const Nav = () => {
  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  return (
    <div className="topbar">
      <div className="inner">
        <div
          id="NavToggleTarget"
          className={
            isActive ? 'navToggleActive' : 'noClass'
          }
          onClick={toggleClass}
        >
          <span>&nbsp;</span>
        </div>
        <LinkWithTitle
          title="Tampa Bay Boating Adventures brand logo"
          to="/"
          className="topbarLogo"
        >
          <img
            src={logo}
            alt="Tampa Bay Boating Adventures brand logo"
          />
        </LinkWithTitle>
        <div className="flex-center">
          <CallBtn callIconVariant="white" />
        </div>
      </div>
      <nav
        id="NavContainerTarget"
        className={
          isActive ? 'navContainerOpen' : 'noClass'
        }
      >
        <div className="navHeader">
          <LinkWithTitle
            to="/"
            className="navLogo"
            title="logo"
          >
            <img
              src={logo}
              alt="Tampa Bay Boating Adventures brand logo"
            />
          </LinkWithTitle>
          <div className="navHeaderBtn">
            <BuyBtn />
            <div className={` ${btn}`}>
              {/* <CallBtn callIconVariant="primary" /> */}
              <AnchorWithTitle
                href="tel:8137428178"
                className="link call-style"
              >
                Call (813) 742-8178
              </AnchorWithTitle>
            </div>
          </div>
        </div>
        <ul className="navMenu">
          <li>
            <LinkWithTitle to="/">Home</LinkWithTitle>
          </li>
          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/services">
                  Services
                </LinkWithTitle>
              }
              content={
                <ul>
                  <li>
                    <LinkWithTitle to="/services/8-hour-private-party-boat-charter">
                      8-Hour Private Party Boat
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/services/6-hour-private-party-boat-charter">
                      6-Hour Private Party Boat
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/services/4-hour-private-party-boat-charter">
                      4-Hour Private Party Boat
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/services/sunset-private-party-boat-charter">
                      3-Hour Sunset Charter
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/services/3-hour-wave-rave-djd-nightime-party-boat-charter">
                      3-Hour Wave Rave Charter
                    </LinkWithTitle>
                  </li>

                  <li>
                    <LinkWithTitle to="/services/private-snorkeling-charters-st-petersburg">
                      Snorkeling Charters
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/services/large-group-charter-boat">
                      Large Group Boat Charter
                    </LinkWithTitle>
                  </li>
                </ul>
              }
            />
          </li>

          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/about">
                  About TBBA
                </LinkWithTitle>
              }
              content={
                <ul>
                  <li>
                    <LinkWithTitle to="/gallery">
                      Gallery
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/our-boat">
                      Our Boat
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/careers">
                      Careers
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/blog">
                      Blog
                    </LinkWithTitle>
                  </li>
                  <li>
                    <LinkWithTitle to="/faqs">
                      FAQs
                    </LinkWithTitle>
                  </li>
                </ul>
              }
            />
          </li>

          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/areas">
                  Areas
                </LinkWithTitle>
              }
              content={
                <ul>
                  <AreasList />
                </ul>
              }
            />
          </li>

          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/destinations">
                  Destinations
                </LinkWithTitle>
              }
              content={
                <ul>
                  <DestinationsList />
                </ul>
              }
            />
          </li>

          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/add-ons">
                  Add Ons
                </LinkWithTitle>
              }
              content={
                <ul>
                  <AddOnsList />
                </ul>
              }
            />
          </li>

          <li>
            <NavCollapsible
              title={
                <LinkWithTitle to="/special-events">
                  Special Events
                </LinkWithTitle>
              }
              content={
                <ul>
                  <SpecialEventsList />
                </ul>
              }
            />
          </li>

          <li>
            <LinkWithTitle to="/contact">
              Contact Us
            </LinkWithTitle>
          </li>
        </ul>

        <div className="navFooter">
          <span>
            &copy; 2024 Tampa Bay Boating Adventures
            &middot; All Rights Reserved. &middot;{' '}
            <LinkWithTitle to="/privacy">
              Privacy Policy
            </LinkWithTitle>
          </span>
        </div>
      </nav>
      <div
        id="NavShieldTarget"
        className={isActive ? 'navShieldOpen' : 'noClass'}
        onClick={toggleClass}
      >
        &nbsp;
      </div>
    </div>
  );
};

export default Nav;
